import { render, staticRenderFns } from "./BastQRMD.vue?vue&type=template&id=36d56035"
import script from "./BastQRMD.vue?vue&type=script&lang=js"
export * from "./BastQRMD.vue?vue&type=script&lang=js"
import style0 from "./BastQRMD.vue?vue&type=style&index=0&id=36d56035&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports